import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Alert } from 'react-native';
import { useAuth } from '@/contexts/AuthContext';
import { router } from 'expo-router';

export default function TestScreen() {
  const { user, signOut } = useAuth();
  
  const handleLogout = async () => {
    try {
      await signOut();
      Alert.alert('Sucesso', 'Logout realizado com sucesso!');
      router.replace('/(auth)/login');
    } catch (error) {
      Alert.alert('Erro', 'Erro ao fazer logout');
    }
  };
  
  const goToLogin = () => {
    router.push('/(auth)/login');
  };
  
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Página de Teste</Text>
      
      {user ? (
        <>
          <Text style={styles.subtitle}>Usuário logado: {user.nome}</Text>
          <Text style={styles.subtitle}>Email: {user.email}</Text>
          
          <TouchableOpacity style={styles.button} onPress={handleLogout}>
            <Text style={styles.buttonText}>Fazer Logout</Text>
          </TouchableOpacity>
        </>
      ) : (
        <>
          <Text style={styles.subtitle}>Nenhum usuário logado</Text>
          
          <TouchableOpacity style={styles.button} onPress={goToLogin}>
            <Text style={styles.buttonText}>Ir para Login</Text>
          </TouchableOpacity>
        </>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#000',
    marginBottom: 20,
  },
  subtitle: {
    fontSize: 16,
    color: '#666',
    marginBottom: 10,
    textAlign: 'center',
  },
  button: {
    backgroundColor: '#007AFF',
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 8,
    marginTop: 20,
  },
  buttonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
});